import { Component, HostListener } from '@angular/core';
import { of, Subscription, combineLatest, concat } from 'rxjs';
import { NavigationStart, Router } from '@angular/router';
import { AuthService } from "./core/auth/auth.service";

import { OverviewService } from 'app/modules/pages/trailer-systems/overview/system-overview.service';

import { FirestoreService } from "./firebase/firestore.service";
import { UserService } from './core/user/user.service';
import { ref, getBlob, getStorage } from 'firebase/storage';
import { getApps } from 'firebase/app';

@Component({
    selector   : 'app-root',
    templateUrl: './app.component.html',
    styleUrls  : ['./app.component.scss']
})
export class AppComponent
{
    subscription: Subscription

    storage = getStorage(getApps()[0]);

    /**
     * Constructor
     */
    constructor(private overviewService: OverviewService, private authService: AuthService, private router: Router, public firestore: FirestoreService)
    {
        /*const backendRef = this.firestore.getDoc('backend','Parameters')
        backendRef.then(snapshot => {
            //console.log(snapshot)
            let on_maintenance = false
            if(snapshot["data"].hasOwnProperty("maintenance")){
                on_maintenance = snapshot["data"]["maintenance"]
            }
            if(on_maintenance){
                this.authService.signOut();
                this.router.navigate(['/maintenance']);
            }
        });*/


        // Check is the website in currently on maintenace
        this.firestore.getCollectionOnChange(`/backend`).subscribe((res: any) => {
            //console.log(res);
            for(var i in res){
                if (res[0]["id"] === "Parameters"){

                    if (res[0]["maintenance"] === true){
                        this.authService.signOut();
                        this.router.navigate(['/maintenance']);
                    }else{
                        //this.router.navigate(['/']);
                    }
                }
            }
        });
        
        this.subscription = router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                let browserRefresh = !router.navigated;
                //console.log(browserRefresh)

                if (browserRefresh){
                    /*console.log("refreshing")
                    let autologin = sessionStorage.getItem('autologin');
                    if(autologin){
                        sessionStorage.removeItem('autologin');
                    }*/
                }
            }
        });
    }


    ngOnDestroy(){

        this.overviewService.removeSystemUser()
    }

    @HostListener('window:beforeunload')
    doSomething() {
        this.overviewService.removeSystemUser()
    }

    /*@HostListener('window:beforeunload', [ '$event' ])
    beforeUnloadHandler(event) {
        //this.authService.closeSession()
    }*/
}
